'use client'
import dynamic from 'next/dynamic'
import React, { useState, useEffect, useRef } from 'react'
// import ContactCardSent from '@components/ContactCardSent'
import { FaUser } from 'react-icons/fa'
import { MdOutlinePhoneIphone, MdEmail } from 'react-icons/md'
import { AiFillWechat } from 'react-icons/ai'
import { FaLine } from 'react-icons/fa'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { useSession } from 'next-auth/react'
import tailwindConfig from '@tailwind.config'
import { Combobox, Listbox } from "@headlessui/react"
import { countryCodes } from '@constants/countryCodes'
import { preferredContact } from '@constants/preferredContact';

import { Dialog } from '@headlessui/react'
import { RiWhatsappFill } from 'react-icons/ri'
import Image from 'next/image'
import Link from 'next/link'
import { IoLogoWhatsapp } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import QRCodeGenerator from '@components/QRCodeGenerator'

const ContactCardSent = dynamic(() => import('@components/ContactCardSent'), {
    ssr: false,
})


const ContactCard = ({ property, status = undefined, dictionary, lang }) => {
    const { data: session } = useSession()

    const [userId, setUserId] = useState(null)
    const [contact, setContact] = useState(preferredContact[lang][0])
    const [phone, setPhone] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [line, setLine] = useState('')
    const [wechat, setWechat] = useState('')
    const [message, setMessage] = useState(`${status == 'sold' || status =='rented' ? dictionary.messageSoldPrompt : dictionary.messagePrompt}`)
    const [hasEnquiry, setHasEnquiry] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState(countryCodes[0].code)
    const [query, setQuery] = useState('')

    const [phoneQrIsOpen, setPhoneQrIsOpen] = useState(false)  
    const [waQrIsOpen, setWaQrIsOpen] = useState(false)  
    const [lineQrIsOpen, setLineQrIsOpen] = useState(false)  
    const [isCopied, setIsCopied] = useState(false);
    const spanRef = useRef(null);

    const copyToClipboard = () => {
        if (spanRef && spanRef.current) {
          const tempInput = document.createElement('input');
          tempInput.value = property.agent.agentContact;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000); // Reset copied state after 2 seconds
        }
      };

    const filteredCountries =
        query === ''
            ? countryCodes
            : countryCodes.filter((country) => {
                return country.country.toLowerCase().includes(query.toLowerCase()) || country.code.toLowerCase().includes(query.toLowerCase())
            })

    // useEffect(() => {
    //     const setUserData = () => {
    //         if (session?.user) {
    //             // console.log(session?.user)
    //             setUserId(session?.user.id)
    //             setName(session?.user.name)
    //             setPhone(session?.user.phone)
    //             setSelectedCountry(session?.user.phonePrefix || countryCodes[0].code)
    //             setEmail(session?.user.email)
    //             setHasEnquiry(property.enquiry)
    //         }
    //     }
    //     setUserData()
    // }, [session])

    useEffect(() => {
        const setUserData = () => {
            const savedDetails = JSON.parse(localStorage.getItem('contactDetails'));

            if (savedDetails) {
                if (savedDetails.name && savedDetails.name !== '') {
                    setName(savedDetails.name);
                }
                if (savedDetails.selectedCountry && savedDetails.selectedCountry !== '') {
                    setSelectedCountry(savedDetails.selectedCountry);
                }
                if (savedDetails.phone && savedDetails.phone !== '') {
                    setPhone(savedDetails.phone);
                }
                if (savedDetails.email && savedDetails.email !== '') {
                    setEmail(savedDetails.email);
                }
                if (savedDetails.contact && savedDetails.contact !== '') {
                    setContact(savedDetails.contact);
                }
                if (savedDetails.line && savedDetails.line !== '') {
                    setLine(savedDetails.line);
                }
                if (savedDetails.wechat && savedDetails.wechat !== '') {
                    setWechat(savedDetails.wechat);
                }

            }
        }
        setUserData()
    }, [])

    const handleForm = async (e) => {
        e.preventDefault()

        const contactDetails = {
            name,
            selectedCountry,
            phone,
            email,
            contact,
            line,
            wechat
        };

        localStorage.setItem('contactDetails', JSON.stringify(contactDetails));

        const { sendContactForm } = await import('@services/sendContactForm')
        await sendContactForm(userId, name, selectedCountry, phone, email, message, property.id, property.agentId, property.saleType, contact, line, wechat)
        setHasEnquiry(true)
    }

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    return (
        <>
            {!hasEnquiry ? (
                <>
                <div className='xl:mb-4 sm:block hidden pb-3 shadow-sm shadow-maincolor/70 xl:border-b-0 border-[1px] border-third rounded-lg bg-gradient-to-br from-[#343333] to-maincolor'>
                    <div className='z-20 flex flex-col justify-between items-center p-4'>
                        <div className='w-full flex flex-row pt-2'>
                            <div className='relative w-[60px] aspect-square rounded-full overflow-hidden'>
                                <Image
                                    className='object-cover hover:shadow-xl'
                                    src={`/images/bullmarklogo.png`}
                                    fill={true}
                                    alt={'BullMark Properties Logo'}
                                />
                            </div>
                            <div className='ml-4 flex flex-col justify-between'>
                                <div>
                                    <p className='text-light text-xl font-semibold'>BullMark Properties</p>
                                    <p className='text-light'>{dictionary.pattayaRealEstate}</p>
                                </div>
                            </div>
                        </div>
                        <div className='w-full mt-4'>
                            <p className='text-light font-semibold text-md mb-2'>{dictionary.contactUsNow}</p>
                            <div className='flex flex-row gap-1'>
                                {property.agent.agentLine && (
                                    <button onClick={() => {setLineQrIsOpen(true)}} title='LINE' href={property.agent.agentLine} className='flex flex-row my-1 justify-center w-1/3 inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-1 px-3 mx-[1px] items-center rounded-full shadow-sm drop-shadow-md' target="_blank">
                                        <FaLine
                                            color={tailwindConfig.theme.extend.colors.light}
                                            size={30}
                                            className=''
                                        />
                                        <span className='w-[70px] text-center text-light font-semibold ml-2'>{dictionary.lineButton}</span>
                                    </button>
                                )}
                                {property.agent.agentWhatsapp && (
                                    <button onClick={() => {setWaQrIsOpen(true)}} title='WhatsApp' href={`${property.agent.agentWhatsapp}`} className='flex flex-row my-1 w-1/3 justify-center bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-3 mx-[1px] items-center rounded-full shadow-sm drop-shadow-md' >
                                        <IoLogoWhatsapp
                                            color={tailwindConfig.theme.extend.colors.light}
                                            size={30}
                                            className=''
                                        />
                                        <span className='w-[70px] text-center text-light font-semibold ml-2'>{dictionary.whatsappButton}</span>
                                    </button>
                                )}
                                {property.agent.agentContact && (
                                    <button onClick={() => {setPhoneQrIsOpen(true)}} title='Mobile' href={`tel:${property.agent.agentContact}`} className='flex flex-row my-1 w-1/3 justify-center bg-gradient-to-r from-third to-third hover:from-third hover:to-third py-1 px-3 mx-[1px] items-center rounded-full shadow-sm drop-shadow-md' target="_blank">
                                        <MdOutlinePhoneAndroid
                                            color={tailwindConfig.theme.extend.colors.maincolor}
                                            size={30}
                                            className=''
                                        />
                                        <span className='w-[70px] text-center text-maincolor font-semibold ml-2'>{dictionary.phoneButton}</span>
                                    </button>
                                )}
                                <Dialog
                                    open={waQrIsOpen}
                                    onClose={() => setWaQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                    <div className="fixed inset-0 bg-black/70" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded-xl bg-maincolor border-[1px] border-third shadow shadow-third p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>
                                                    <span className='text-maincolor'>
                                                        BullMark Properties
                                                    </span>
                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setWaQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator url={`${property.agent.agentWhatsapp}`} dictionary={dictionary} />
                                                <div className='w-full flex flex-row justify-center items-center'>
                                                    <Link className='w-full bg-[#25D366] text-light p-2 rounded-md text-center' href={property.agent.agentWhatsapp}>{dictionary.openWhatsappInBrowser}</Link>
                                                </div>
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                                <Dialog
                                    open={lineQrIsOpen}
                                    onClose={() => setLineQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                    <div className="fixed inset-0 bg-black/70" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded-xl bg-maincolor border-[1px] border-third shadow shadow-third p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>
                                                    <span className='text-maincolor'>
                                                        BullMark Properties
                                                    </span>
                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setLineQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator url={`${property.agent.agentLine}`} dictionary={dictionary} />
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                                <Dialog
                                    open={phoneQrIsOpen}
                                    onClose={() => setPhoneQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                    <div className="fixed inset-0 bg-black/70" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded-xl bg-maincolor border-[1px] border-third shadow shadow-third p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>
                                                    <span className='text-maincolor'>
                                                        BullMark Properties
                                                    </span>
                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setPhoneQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator url={`tel:${property.agent.agentContact}`} dictionary={dictionary} />
                                                <div className='text-light mb-4'>{dictionary.or}</div>
                                                <div className='w-full bg-light rounded-xl flex flex-row justify-center items-center py-2'>
                                                    <span ref={spanRef} className='text-maincolor'>{property.agent.agentContact}</span>
                                                    <button title='Click to copy to clipboard' onClick={copyToClipboard} className='bg-maincolor text-light px-2 rounded-md ml-4'>{isCopied ? `${dictionary.copied}` : `${dictionary.copy}`}</button>
                                                </div>
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='xl:mb-0 pb-3 shadow-sm shadow-maincolor/70 xl:border-b-0 border-[1px] border-third rounded-lg bg-gradient-to-br from-[#343333] to-maincolor'>
                    <div className='w-full p-4'>
                        <h2 className='text-light font-semibold text-xl mb-1'>{dictionary.title}</h2>
                        <form onSubmit={handleForm}>
                            <label className='text-light text-md mb-2'>{dictionary.name}</label>
                            <div className='z-1 mb-4 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                <FaUser
                                    color={tailwindConfig.theme.extend.colors.third}
                                    size={28}
                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                />
                                <input
                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                    placeholder={dictionary.namePlaceholder}
                                    type='text'
                                    name='name'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <label className='text-light text-md mb-2'>{dictionary.preferredContact}</label>
                            <Listbox className="mb-4" value={contact} onChange={setContact}>
                                <div className='z-1 relative w-full cursor-default rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none  sm:text-sm" aria-label="Phone Dropdown">
                                        <span className="block truncate">{contact.name}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={tailwindConfig.theme.extend.colors.third}
                                                size={32}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50" aria-label="Select Preferred Contact Method">
                                        {preferredContact[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                                aria-label={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.name}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                            {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                <>
                                    <label className='text-light text-md mb-2'>{dictionary.phone}</label>
                                    <div className='flex flex-row w-full mb-4'>
                                        {/* <CountryCode className="w-1/4" /> */}
                                        <Combobox className="w-1/4"
                                            value={selectedCountry}
                                            onChange={setSelectedCountry}
                                        >
                                            <div className="relative w-full">
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.third}
                                                            size={32}
                                                        />
                                                    </Combobox.Button>
                                                </div>
                                                <Combobox.Options
                                                    as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                    className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                    aria-label="Country Code Select"
                                                >
                                                    {filteredCountries.map((country) => (
                                                        <Combobox.Option
                                                            key={country.id}
                                                            value={country.code}
                                                            className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                        >
                                                            {country.code} {country.country}
                                                        </Combobox.Option>
                                                    ))}
                                                </Combobox.Options>
                                            </div>
                                        </Combobox>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <MdOutlinePhoneIphone
                                                color={tailwindConfig.theme.extend.colors.third}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.phonePlaceholder}
                                                required
                                                type='text'
                                                name='phone'
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <>
                                        <label className='text-light text-md mb-2'>{dictionary.email}</label>
                                        <div className='w-full mb-4'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdEmail
                                                    color={tailwindConfig.theme.extend.colors.third}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.email}
                                                    type='email'
                                                    name='email'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                </>
                            )}
                            {(contact.value == 'line') && (
                                <>
                                    <label className='text-light text-md mb-2'>{dictionary.line}</label>
                                    <div className='w-full mb-4'>
                                        <div className='z-1 mb-4 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <FaLine
                                                color={tailwindConfig.theme.extend.colors.third}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.linePlaceholder}
                                                type='line'
                                                name='line'
                                                value={line}
                                                onChange={(e) => setLine(e.target.value)}
                                                required
                                                aria-label="LINE ID Input"
                                            />
                                        </div>
                                        <label className='text-light text-md mb-2'>{dictionary.phone}</label>
                                        <div className='flex flex-row w-full mb-4'>
                                            {/* <CountryCode className="w-1/4" /> */}
                                            <Combobox className="w-1/4"
                                                value={selectedCountry}
                                                onChange={setSelectedCountry}
                                            >
                                                <div className="relative w-full">
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                            <RiArrowDropDownLine
                                                                color={tailwindConfig.theme.extend.colors.third}
                                                                size={32}
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Combobox.Options
                                                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                        className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                        aria-label="Country Code Select"
                                                    >
                                                        {filteredCountries.map((country) => (
                                                            <Combobox.Option
                                                                key={country.id}
                                                                value={country.code}
                                                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                            >
                                                                {country.code} {country.country}
                                                            </Combobox.Option>
                                                        ))}
                                                    </Combobox.Options>
                                                </div>
                                            </Combobox>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdOutlinePhoneIphone
                                                    color={tailwindConfig.theme.extend.colors.third}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.phonePlaceholder}s
                                                    type='text'
                                                    name='phone'
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <>
                                            <label className='text-light text-md mb-2'>{dictionary.email}</label>
                                            <div className='w-full mb-4'>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdEmail
                                                        color={tailwindConfig.theme.extend.colors.third}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.email}
                                                        type='email'
                                                        name='email'
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'wechat') && (
                                <>
                                    <label className='text-light text-md mb-2'>{dictionary.wechat}</label>
                                    <div className='w-full mb-4'>
                                        <div className='z-1 mb-4 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                            <AiFillWechat
                                                color={tailwindConfig.theme.extend.colors.third}
                                                size={30}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.wechatPlaceholder}
                                                type='wechat'
                                                name='wechat'
                                                value={wechat}
                                                onChange={(e) => setWechat(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <>
                                            <label className='text-light text-md mb-2'>{dictionary.phone}</label>
                                            <div className='flex flex-row w-full mb-4'>
                                                {/* <CountryCode className="w-1/4" /> */}
                                                <Combobox className="w-1/4"
                                                    value={selectedCountry}
                                                    onChange={setSelectedCountry}
                                                >
                                                    <div className="relative w-full">
                                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                            <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                                <RiArrowDropDownLine
                                                                    color={tailwindConfig.theme.extend.colors.third}
                                                                    size={32}
                                                                />
                                                            </Combobox.Button>
                                                        </div>
                                                        <Combobox.Options
                                                            as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                            className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                            aria-label="Country Code Select"
                                                        >
                                                            {filteredCountries.map((country) => (
                                                                <Combobox.Option
                                                                    key={country.id}
                                                                    value={country.code}
                                                                    className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                                >
                                                                    {country.code} {country.country}
                                                                </Combobox.Option>
                                                            ))}
                                                        </Combobox.Options>
                                                    </div>
                                                </Combobox>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdOutlinePhoneIphone
                                                        color={tailwindConfig.theme.extend.colors.third}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.phonePlaceholder}
                                                        type='text'
                                                        name='phone'
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        <>
                                            <label className='text-light text-md mb-2'>{dictionary.email}</label>
                                            <div className='w-full mb-4'>
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                    <MdEmail
                                                        color={tailwindConfig.theme.extend.colors.third}
                                                        size={30}
                                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                    />
                                                    <input
                                                        className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                        placeholder={dictionary.email}
                                                        type='email'
                                                        name='email'
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'email') && (
                                <>
                                    <>
                                        <label className='text-light text-md mb-2'>{dictionary.email}</label>
                                        <div className='w-full mb-4'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdEmail
                                                    color={tailwindConfig.theme.extend.colors.third}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.email}
                                                    type='email'
                                                    name='email'
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </>
                                    <>
                                        <label className='text-light text-md'>{dictionary.phone}</label>
                                        <div className='flex flex-row w-full mb-4'>
                                            {/* <CountryCode className="w-1/4" /> */}
                                            <Combobox className="w-1/4"
                                                value={selectedCountry}
                                                onChange={setSelectedCountry}
                                            >
                                                <div className="relative w-full">
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                            <RiArrowDropDownLine
                                                                color={tailwindConfig.theme.extend.colors.third}
                                                                size={32}
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Combobox.Options
                                                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                        className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-md py-1'
                                                        aria-label="Country Code Select"
                                                    >
                                                        {filteredCountries.map((country) => (
                                                            <Combobox.Option
                                                                key={country.id}
                                                                value={country.code}
                                                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                            >
                                                                {country.code} {country.country}
                                                            </Combobox.Option>
                                                        ))}
                                                    </Combobox.Options>
                                                </div>
                                            </Combobox>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdOutlinePhoneIphone
                                                    color={tailwindConfig.theme.extend.colors.third}
                                                    size={30}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10 text-sm leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.phonePlaceholder}
                                                    type='text'
                                                    name='phone'
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                </>
                            )}
                            <label className='text-light text-md mb-2'>{dictionary.message}</label>
                            <div className='w-full mb-2'>
                                <textarea
                                    className='w-full border-[1px] border-forth text-black rounded-md p-2'
                                    placeholder='Please enter your question on request'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    rows={3}
                                    required
                                />
                            </div>
                            <button className='w-full p-2 bg-third text-maincolor font-bold rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.12)]' type='submit'>{dictionary.send}</button>
                        </form>
                    </div>
                </div></>) : (
                <ContactCardSent enquiryId={property.enquiryId} propertyId={property.id} email={email} dictionary={dictionary} lang={lang} />
            )}
        </>
    )
}

export default ContactCard